import Proxy from './Proxy';

class EntryProxy extends Proxy
{
    constructor( parameters = {})
    {
        super( 'api/entries', parameters );
    }
}

export default EntryProxy;
